<template>
  <!-- Start combobox + expansion panel to filter users columns-->
  <div class="combobox-group neumorphism-in">
    <div>{{ $t("filters.userTitle") }}</div>

    <div>
      <!-- Start Menu Users -->
      <v-combobox
        v-model="usersMultiArray.users"
        :items="usersDisplayed"
        :label="$t('filters.employeesFilter')"
        item-text="fullname"
        item-value="details.id"
        @input="MultifilterUsers"
        multiple
        clearable
        background-color="transparent"
        item-color="red"
        color="red"
      >
        <!-- Start tags Users -->
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index === 0">
            <span>{{ item.details.lastName }}</span>
          </v-chip>
          <span v-if="index === 1" class="grey--text caption">
            (+{{ usersMultiArray.users.length - 1 }} {{ $t("filters.others") }})
          </span>
        </template>
        <!-- End tags Users -->
        <!-- End Menu Users -->
      </v-combobox>
    </div>

    <div>
      <v-combobox
        v-model="usersMultiArray.locations"
        :items="sortedLocations"
        item-text="city"
        item-value="id"
        :label="$t('filters.citiesFilter')"
        @input="MultifilterCities"
        multiple
        clearable
        background-color="transparent"
        item-color="red"
        color="red"
      >
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index === 0">
            <span>{{ item.city }}</span>
          </v-chip>
          <span v-if="index === 1" class="grey--text caption">
            (+{{ usersMultiArray.locations.length - 1 }}
            {{ $t("filters.others") }})
          </span>
        </template>
      </v-combobox>
    </div>

    <div no-gutters>
      <v-combobox
        v-model="usersMultiArray.skills"
        :items="sortedSkills"
        item-text="title"
        item-value="id"
        :label="$t('filters.skillsFilter')"
        @input="MultifilterSkills"
        multiple
        clearable
        background-color="transparent"
        item-color="red"
        color="red"
      >
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index === 0">
            <span>{{ item.title }}</span>
          </v-chip>
          <span v-if="index === 1" class="grey--text caption">
            (+{{ usersMultiArray.skills.length - 1 }}
            {{ $t("filters.others") }})
          </span>
        </template>
      </v-combobox>
    </div>

    <div no-gutters>
      <v-combobox
        v-model="usersMultiArray.companies"
        :items="companies"
        item-text="text"
        item-value="value"
        :label="$t('filters.companiesFilter')"
        @input="MultifilterCompanies"
        multiple
        clearable
        background-color="transparent"
        item-color="red"
        color="red"
      >
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index === 0">
            <span>{{ item.text }}</span>
          </v-chip>
          <span v-if="index === 1" class="grey--text caption">
            (+{{ usersMultiArray.companies.length - 1 }}
            {{ $t("filters.others") }})
          </span>
        </template>
      </v-combobox>
    </div>
  </div>
  <!-- End combobox + expansion panel to filter users columns-->
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: [],
  data() {
    return {
      companies: this.$enumUserCompany,
      usersDisplayed: [],
      sortedSkills: [],
      sortedLocations: [],
      filtering: false,
    };
  },
  computed: {
    ...mapGetters("locationModule", { locations: "getLocations" }),
    ...mapGetters("userModule", {
      users: "getUsersForm",
      notAssignedUsers: "getNotAssignedUsers",
      calendar: "getCalendar",
      usersMultiArray: "getUsersMultiArray",
    }),
    ...mapGetters("eventModule", {
      events: "getEvents",
      eventsMultiArray: "getEventsMultiarray",
    }),
  },
  watch: {
    calendar: function () {
      this.clearUsersMultiArray();
      this.changeUsersList();
    },
    "eventsMultiArray.city": function () {
      this.onEventsMultiArrayPropertyChanged();
    },
    "eventsMultiArray.course": function () {
      this.onEventsMultiArrayPropertyChanged();
    },
    "eventsMultiArray.option": function () {
      this.onEventsMultiArrayPropertyChanged();
    },
    "eventsMultiArray.validated": function () {
      this.onEventsMultiArrayPropertyChanged();
    },
  },
  mounted() {
    //this.$nextTick in order to call users from Parent in the mounted method (Vue.js life cycle)
    this.$nextTick(() => this.clearUsersMultiArray());
    this.changeUsersList();
    this.sortedSkills = this.skills.sort((a, b) =>
      a.title.localeCompare(b.title)
    );
    this.sortedLocations = this.locations.sort((a, b) =>
      a.city.localeCompare(b.city)
    );
  },
  methods: {
    ...mapActions("eventModule", ["updateEventsMultiarray"]),
    ...mapActions("userModule", ["updateUsersMultiarray"]),

    /**
     * This method will load usersMultiArray empty: { locations: [], users: [], skills: [], companies: [] }
     * usersMultiArray is an object used to save parameters selected by the client for the user filter
     */
    clearUsersMultiArray() {
      this.updateUsersMultiarray({
        locations: [],
        users: [],
        skills: [],
        companies: [],
      });
    },
    clearEventsMultiArray() {
      this.updateEventsMultiarray({
        city: null,
        option: null,
        validated: null,
      });
    },

    onEventsMultiArrayPropertyChanged() {
      if (!this.filtering) {
        this.usersDisplayed.forEach((u) => {
          u.display = true;
        });
        this.clearUsersMultiArray();
      }
    },
    changeUsersList() {
      if (this.calendar === "INTERVNOTASSIGN") {
        this.usersDisplayed = this.notAssignedUsers;
      } else {
        this.usersDisplayed = this.users;
      }
      this.usersDisplayed = this.usersDisplayed.sort((a, b) =>
        a.fullname.localeCompare(b.fullname)
      );
    },
    /**
     * This method will fill this.usersMultiArray.locations with existing users
     */
    LoadMultifilterCities() {
      this.usersMultiArray.users.forEach((user) => {
        const myCity = this.locations.filter(
          (c) => c.city === user.location
        )[0];
        if (!this.usersMultiArray.locations.includes(myCity))
          this.usersMultiArray.locations.push(myCity);
      });
    },
    /**
     * This method will fill this.usersMultiArray.skills with existing users
     */
    LoadMultifilterSkills() {
      this.usersMultiArray.users.forEach((user) => {
        if (user.details.skills != null) {
          user.details.skills.forEach((s) => {
            this.skills.forEach((skill) => {
              if (s.id === skill.id) {
                this.usersMultiArray.skills.push(skill);
              }
            });
          });
        }
      });
      let skillsNoDuplicate = this.removeDuplicates(
        this.usersMultiArray.skills
      );
      this.usersMultiArray.skills = skillsNoDuplicate;
    },
    /**
     * This method will fill this.usersMultiArray.companies with existing users
     */
    LoadMultifilterCompanies() {
      this.usersMultiArray.users.forEach((user) => {
        const myCompany = this.companies.filter(
          (c) => c.value === user.details.company
        )[0];
        if (!this.usersMultiArray.companies.includes(myCompany))
          this.usersMultiArray.companies.push(myCompany);
      });
    },
    /**
     * This method will show (display = true) users selected in Multifilters;
     */
    filteredUsersLayout() {
      this.usersDisplayed.forEach((u) => {
        this.usersMultiArray.users.forEach((user) => {
          if (u.id === user.id) {
            this.usersMultiArray.locations.forEach((city) => {
              if (u.location === city.city) {
                this.usersMultiArray.companies.forEach((company) => {
                  if (u.details.company === company.value) {
                    this.usersMultiArray.skills.forEach((skill) => {
                      if (u.details.skills != null) {
                        u.details.skills.forEach((s) => {
                          if (s.id === skill.id) u.display = true;
                        });
                      } else if (u.details.skills === null) u.display = true;
                    });

                    // if unselect all users with skills > this.usersMultiArray.skills.length will be 0
                    // but we can still have user with skillsId === null
                    if (this.usersMultiArray.skills.length === 0) {
                      u.display = true;
                    }
                  }
                });
              }
            });
          }
        });
      });
    },
    /**
     * This method will show (display = true) events from Users selected in Multifilters
     */
    filteredEventsLayout() {
      this.events.forEach((evt) => {
        this.usersMultiArray.users.forEach((user) => {
          if (evt.details.user.id === user.id) {
            evt.display = true;
          }
        });
      });
    },

    beforeFiltering() {
      this.filtering = true;

      //clear City/Option Array
      this.clearEventsMultiArray();

      //Method triggered while using Users Multifilter
      this.userAndEventDisplay(false);
    },
    afterFiltering() {
      //if all filters are empty need to display users and events to true
      this.verifyEmptyUsersMultiarray();

      //Display users with their events
      this.filteredUsersLayout();
      this.filteredEventsLayout();

      this.$nextTick(() => (this.filtering = false));
    },

    /**
     * This method will filter users depending of users name selected
     */
    MultifilterUsers() {
      this.beforeFiltering();

      //show skills having users selected
      this.usersMultiArray.skills = [];
      this.LoadMultifilterSkills();
      //show cities having users selected
      this.usersMultiArray.locations = [];
      this.LoadMultifilterCities();
      //show companies having users selected
      this.usersMultiArray.companies = [];
      this.LoadMultifilterCompanies();

      this.afterFiltering();
    },
    /**
     * This method will filter users depending of cities selected
     */
    MultifilterCities() {
      this.beforeFiltering();

      //show users having cities selected
      this.usersMultiArray.users = [];

      this.usersDisplayed.forEach((u) => {
        let myCity = this.locations.filter((c) => c.city === u.location)[0];
        if (this.usersMultiArray.locations.includes(myCity))
          this.usersMultiArray.users.push(u);
      });

      let usersNoDuplicate = this.removeDuplicates(this.usersMultiArray.users);
      this.usersMultiArray.users = usersNoDuplicate;

      //show skills having users selected
      this.usersMultiArray.skills = [];
      this.LoadMultifilterSkills();
      //show companies having users selected
      this.usersMultiArray.companies = [];
      this.LoadMultifilterCompanies();

      this.afterFiltering();
    },
    /**
     * This method will filter users depending of skills selected
     */
    MultifilterSkills() {
      this.beforeFiltering();

      //show users having skills selected
      this.usersMultiArray.users = [];

      for (let i = 0; i < this.usersDisplayed.length; i++) {
        if (this.users[i].details.skills != null) {
          this.users[i].details.skills.forEach((s) => {
            this.usersMultiArray.skills.forEach((skill) => {
              if (s.id === skill.id) {
                this.usersMultiArray.users.push(this.users[i]);
              }
            });
          });
        }
      }

      let usersNoDuplicate = this.removeDuplicates(this.usersMultiArray.users);
      this.usersMultiArray.users = usersNoDuplicate;

      //show companies having users selected
      this.usersMultiArray.companies = [];
      this.LoadMultifilterCompanies();
      //show cities having users selected
      this.usersMultiArray.locations = [];
      this.LoadMultifilterCities();

      this.afterFiltering();
    },
    /**
     * This method will filter users depending of companies selected
     */
    MultifilterCompanies() {
      this.beforeFiltering();

      //show users having companies selected
      this.usersMultiArray.users = [];
      this.usersDisplayed.forEach((u) => {
        const myCompany = this.companies.filter(
          (c) => c.value === u.details.company
        )[0];
        if (this.usersMultiArray.companies.includes(myCompany)) {
          this.usersMultiArray.users.push(u);
        }
      });

      let usersNoDuplicate = this.removeDuplicates(this.usersMultiArray.users);
      this.usersMultiArray.users = usersNoDuplicate;

      //show skills having users selected
      this.usersMultiArray.skills = [];
      this.LoadMultifilterSkills();
      //show cities having users selected
      this.usersMultiArray.locations = [];
      this.LoadMultifilterCities();

      this.afterFiltering();
    },
    /**
     * This method will remove duplicate from an array
     *
     * @param  {Array} data Array in which one we want to remove duplicate
     * @returns {Array} Array without duplicate
     */
    removeDuplicates(data) {
      return data.filter((value, index) => data.indexOf(value) === index);
    },
    /**
     * This method will change the display of all users and events
     * @param  {boolean} boolean If we want to display all users and events we will pass 'true' otherwise we will pass 'false'
     */
    userAndEventDisplay(boolean) {
      this.usersDisplayed.forEach((user) => {
        user.display = boolean;
      });
      this.events.forEach((evt) => {
        evt.display = boolean;
      });
    },
    /**
     * If all filters are empty need to display users and events to true
     */
    verifyEmptyUsersMultiarray() {
      if (
        this.usersMultiArray.locations.length === 0 &&
        this.usersMultiArray.users.length === 0 &&
        this.usersMultiArray.skills.length === 0 &&
        this.usersMultiArray.companies.length === 0
      ) {
        this.usersDisplayed.forEach((user) => {
          user.display = true;
        });
        this.events.forEach((evt) => {
          evt.display = true;
        });
      }
    },
  },
};
</script>

<style>
/*START ADVANCED RESEARCHE*/
.combobox-group {
  padding: 20px;
  border-radius: 20px;
}

#advancedResearch > div {
  background-color: rgba(255, 255, 255, 0);
  box-shadow: none;
  border-radius: 0;
}

/*END ADVANCED RESEARCHE*/
</style>
